import React from 'react';
import { ShieldCheck } from 'lucide-react';

/**
 * Reassures buyers that the final amount is shown before paying,
 * with no hidden fees.
 */
export const SecurePaymentNote = ({
  className = ''
}: {
  className?: string;
}) => <div className={`mx-auto flex w-full max-w-[320px] items-start gap-2.5 rounded-2xl border border-sky-400/25 bg-sky-400/[0.06] px-3.5 py-2.5 ${className}`} data-id="element-366" data-mp="1c8h8zwp7p49a">
    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-400/15 text-sky-400" data-id="element-367" data-mp="1m7ycq8kwl82m">
      <ShieldCheck size={13} aria-hidden="true" data-id="element-368" data-mp="1q7yqrs43bh95" />
    </span>
    <div className="min-w-0 text-left" data-id="element-369" data-mp="1uzqii5yzft0v">
      <p className="text-[10px] font-bold uppercase tracking-widest text-sky-400" data-id="element-370" data-mp="1v0rwojbaovmt">
        Paiement sécurisé et transparent
      </p>
      <p className="mt-0.5 text-xs leading-snug text-slate-300" data-id="element-371" data-mp="200xr278y8w8l">
        Le montant final s’affiche avant de payer. Aucune surprise, aucun frais caché.
      </p>
    </div>
  </div>;